import type { TypeFilterType } from '@inovua/reactdatagrid-community/types';
import { isArray, isNull } from 'lodash';

// ----------------------------------------------------------------------

type SelectByIdInlineOperatorProps = {
  value: { id: number | string } | null;
  filterValue: Array<number | string>;
};

type SelectByNameInlineOperatorProps = {
  value?: { name: string; full_name: string };
  filterValue: Array<number | string>;
};

type SelectByUserRoleInlineOperatorProps = {
  value: string[];
  filterValue: string[] | null;
};

type SelectByPlansInlineOperatorProps = {
  value: Array<{ plan: number; bonus: number }>;
  filterValue: number | string;
};

type SelectBySearchNameInlineOperatorProps = {
  value?: { name: string; search_string: string };
  filterValue: Array<number | string>;
};

// ----------------------------------------------------------------------

export const filterTypes = {
  'select-by-id': {
    type: 'select-by-id',
    emptyValue: null,
    operators: [
      {
        name: 'inlist',
        fn: ({ value, filterValue }: SelectByIdInlineOperatorProps) => {
          if (isNull(value)) {
            return false;
          }

          if (!filterValue || filterValue.length === 0) {
            return true;
          }

          return filterValue.includes(value.id);
        },
      },
    ],
  } as TypeFilterType,

  'select-by-name': {
    type: 'select-by-name',
    emptyValue: null,
    operators: [
      {
        name: 'inlist',
        fn: ({ value, filterValue }: SelectByNameInlineOperatorProps) => {
          if (!filterValue || filterValue.length === 0) {
            return true;
          }

          return filterValue.includes(value?.name ?? '');
        },
      },
    ],
  } as TypeFilterType,

  'select-by-full_name': {
    type: 'select-by-full_name',
    emptyValue: null,
    operators: [
      {
        name: 'inlist',
        fn: ({ value, filterValue }: SelectByNameInlineOperatorProps) => {
          if (!filterValue || filterValue.length === 0) {
            return true;
          }

          return filterValue.includes(value?.full_name ?? '');
        },
      },
    ],
  } as TypeFilterType,

  'select-by-user-role': {
    type: 'select-by-user-role',
    emptyValue: null,
    operators: [
      {
        name: 'contains',
        fn: ({ value, filterValue }: SelectByUserRoleInlineOperatorProps) => {
          if (!Array.isArray(filterValue) || filterValue.length === 0) {
            return true;
          }

          return value.some(val => filterValue.includes(val));
        },
      },
    ],
  } as TypeFilterType,

  'select-by-bonus': {
    type: 'select-by-bonus',
    emptyValue: null,
    operators: [
      {
        name: 'inlist',
        fn: ({ value, filterValue }: SelectByPlansInlineOperatorProps) => {
          if (!isArray(filterValue) || filterValue.length === 0) {
            return true;
          }

          return value.some(val => filterValue.includes(val.bonus));
        },
      },
    ],
  } as TypeFilterType,

  'select-by-plans': {
    type: 'select-by-plans',
    emptyValue: null,
    operators: [
      {
        name: 'inlist',
        fn: ({ value, filterValue }: SelectByPlansInlineOperatorProps) => {
          if (!isArray(filterValue) || filterValue.length === 0) {
            return true;
          }

          return value.some(val => filterValue.includes(val.plan));
        },
      },
    ],
  } as TypeFilterType,

  'select-by-search_string': {
    type: 'select-by-search_string',
    emptyValue: null,
    operators: [
      {
        name: 'inlist',
        fn: ({ value, filterValue }: SelectBySearchNameInlineOperatorProps) => {
          if (!filterValue || filterValue.length === 0) {
            return true;
          }

          return filterValue.includes(value?.search_string ?? '');
        },
      },
    ],
  } as TypeFilterType,
};
